// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3bc4614c","989":"729b51b4"}[chunkId] + ".chunk.js";
};